import { CheckOutlined } from '@ant-design/icons';
import { Button } from '@mm/components';
import { useConnectedPageCRUDActions } from '@mm/state/actions/ConnectedPageCRUDActions';
import { selectActiveCompanyId } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Logo } from '../../../layout/BotBuilderSidebar/Logo/Logo';
import { HighLevelSignupLayout } from '../../../modules/LoginRouter/components/LoginLayout/BlueLayout/HighLevelSignupLayout';
import { BotBuilderRoutes } from '../../../routes/bot-builder-routes';
import { Routes } from '../../../routes/top-level-routes';
import css from './SelfService.module.css';

export const SelfService = () => {
  const companyId = useSelector(selectActiveCompanyId);
  const facebookPage = useSelector(
    (state: StoreState) => state.connectedPage.entities[0],
  );
  const { retrieveAll } = useConnectedPageCRUDActions();

  const history = useHistory();
  const location = useLocation<{ withSkipButton: boolean }>();
  const withSkipButton = location.state?.withSkipButton;

  const planPoints = [
    'X-Ray Pixel',
    'Advanced X-Ray Pixel settings',
    'Email automations',
    'Signs of life detector',
    'Suppression lists',
    'AI copywriting',
    'Contact Enrichment',
    'Restore - Ad retargeting sync',
    'Email deliverability tools',
  ];
  const prices = [
    '$0.25 Per contact captured',
    '$0.02 Per email send',
    '$0.01 Per social send',
    '$0.05 Per consumer directory lead',
  ];

  const onClick = () => {
    history.push(Routes.subscribe.getLink('salesselfserve_2023_introductory'), {
      showCompanySelect: true,
    });
  };

  const continueToDashboard = async () => {
    if (facebookPage) {
      history.push(
        BotBuilderRoutes.dashboard.getLink({
          chatbotId: facebookPage?.activeBotId,
        }),
      );
    }
  };

  useEffect(() => {
    if (!facebookPage?.activeBotId && companyId) {
      retrieveAll({ companyId, light: true });
    }
  }, []);

  return (
    <div className={css.wrapper}>
      <div className={css.background}>
        <div className={css.left}>
          <Logo className={css.desktopLogo} />
          <HighLevelSignupLayout css={{ container: css.description }} />
        </div>
        <div className={classNames(css.right)}>
          <div
            className={classNames(
              css.headlineContainer,
              css.rightHeadlineContainer,
            )}
          >
            <div className={css.planBlock}>
              <div className={css.headline}>
                Try our Introductory plan
                {withSkipButton && (
                  <Button
                    color="secondary-blue"
                    css={{
                      container: classNames(css.button, css.secondaryButton),
                    }}
                    onClick={continueToDashboard}
                  >
                    Continue to the app
                  </Button>
                )}
              </div>
              <div className={css.priceBlock}>
                <div className={css.price}>
                  <span>Starts at:</span>{' '}
                  <span className={css.priceTag}>
                    $99<span className={css.price}>/mo</span>
                  </span>
                </div>

                <Button css={{ container: css.button }} onClick={onClick}>
                  Get Started
                </Button>
              </div>
            </div>
            <div className={css.grid}>
              <span className={css.gridLabel}>What you get?</span>
              <div className={css.pointsBlock}>
                {planPoints.map(p => (
                  <span className={css.point} key={p}>
                    <CheckOutlined className={css.checkIcon} /> {p}
                  </span>
                ))}
              </div>
              <span className={classNames(css.gridLabel, css.priceLabel)}>
                Cost Per Contact
              </span>
              <div className={classNames(css.pointsBlock, css.pricePoints)}>
                {prices.map(p => (
                  <span className={css.point} key={p}>
                    {p}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
